<template>
    <!-- 通栏布局 -->
    <template v-if="layout == 'header'">
        <header class="adminui-header">
            <div class="adminui-header-left">
                <div class="logo-bar">
                    <img class="logo" :title="config.AppName" src="@/assets/image/logo.png">
                    <span>{{ config.AppName }}</span>
                </div>
                <ul v-if="!ismobile" class="nav">
                    <li v-for="item in navList" :key="item" :class="pmenu.path==item.path ? 'active' : ''" @click="showMenu(item)">
                        <ui-icon v-if="item.icon" :type="item.icon" class="el-menu-top-icon" />
                        <span>{{ item.meta.title }}</span>
                    </li>
                </ul>
            </div>
            <div class="adminui-header-right">
                <userbar></userbar>
            </div>
        </header>
        <section class="aminui-wrapper">
            <div v-if="!ismobile && nextMenu.length>0 || !pmenu.component" :class="menuIsCollapse ? 'aminui-side isCollapse' : 'aminui-side'">
                <div v-if="!menuIsCollapse" class="adminui-side-top">
                    <h2>{{ pmenu.meta.title }}</h2>
                </div>
                <div class="adminui-side-scroll">
                    <el-scrollbar>
                        <el-menu :default-active="active" router :collapse="menuIsCollapse" unique-opened>
                            <nav-menu :navMenus="nextMenu"></nav-menu>
                        </el-menu>
                    </el-scrollbar>
                </div>
                <div class="adminui-side-bottom" @click="onMenuIsCollapse">
                    <el-icon><el-icon-expand v-if="menuIsCollapse"/><el-icon-fold v-else /></el-icon>
                </div>
            </div>
            <side-m v-if="ismobile"></side-m>
            <div class="aminui-body el-container">
                <topbar v-if="!ismobile"></topbar>
                <tags v-if="!ismobile && layoutTags"></tags>
                <div class="adminui-main" id="adminui-main">
                    <router-view v-slot="{ Component }">
                        <keep-alive :include="keepLiveRoute">
                            <component :is="Component" :key="$route.fullPath" v-if="routeShow"/>
                        </keep-alive>
                    </router-view>
                    <iframe-view></iframe-view>
                </div>
            </div>
        </section>
    </template>
    <!-- 经典布局 -->
    <template v-else-if="layout == 'menu'">
        <header class="adminui-header">
            <div class="adminui-header-left">
                <div class="logo-bar">
                    <img class="logo" :title="config.AppName" src="@/assets/image/logo.png">
                    <span>{{ config.AppName }}</span>
                </div>
            </div>
            <div class="adminui-header-right">
                <userbar></userbar>
            </div>
        </header>
        <section class="aminui-wrapper">
            <div v-if="!ismobile" :class="menuIsCollapse ? 'aminui-side isCollapse' : 'aminui-side'">
                <div class="adminui-side-scroll">
                    <el-scrollbar>
                        <el-menu :default-active="active" router :collapse="menuIsCollapse" :unique-opened="true">
                            <nav-menu :navMenus="navList"></nav-menu>
                        </el-menu>
                    </el-scrollbar>
                </div>
                <div class="adminui-side-bottom" @click="onMenuIsCollapse">
                    <el-icon><el-icon-expand v-if="menuIsCollapse"/><el-icon-fold v-else /></el-icon>
                </div>
            </div>
            <side-m v-if="ismobile"></side-m>
            <div class="aminui-body el-container">
                <topbar v-if="!ismobile"></topbar>
                <tags v-if="!ismobile && layoutTags"></tags>
                <div class="adminui-main" id="adminui-main">
                    <router-view v-slot="{ Component }">
                        <keep-alive :include="keepLiveRoute">
                            <component :is="Component" :key="$route.fullPath" v-if="routeShow"/>
                        </keep-alive>
                    </router-view>
                    <iframe-view></iframe-view>
                </div>
            </div>
        </section>
    </template>

    <!-- 功能坞布局 -->
    <template v-else-if="layout == 'dock'">
        <header class="adminui-header">
            <div class="adminui-header-left">
                <div class="logo-bar">
                    <img class="logo" :title="config.AppName" src="@/assets/image/logo.png">
                    <span>{{ config.AppName }}</span>
                </div>
            </div>
            <div class="adminui-header-right">
                <div v-if="!ismobile" class="adminui-header-menu" style="flex: 1">
                    <el-menu mode="horizontal" :default-active="active" router background-color="#222b45" text-color="#fff" active-text-color="var(--el-color-primary)">
                        <nav-menu :navMenus="navList"></nav-menu>
                    </el-menu>
                </div>
                <side-m v-if="ismobile"></side-m>
                <userbar></userbar>
            </div>
        </header>
        <section class="aminui-wrapper">
            <div class="aminui-body el-container">
                <tags v-if="!ismobile && layoutTags"></tags>
                <div class="adminui-main" id="adminui-main">
                    <router-view v-slot="{ Component }">
                        <keep-alive :include="keepLiveRoute">
                            <component :is="Component" :key="$route.fullPath" v-if="routeShow"/>
                        </keep-alive>
                    </router-view>
                    <iframe-view></iframe-view>
                </div>
            </div>
        </section>
    </template>

    <!-- 默认布局 -->
    <template v-else>
        <section class="aminui-wrapper">
            <div v-if="!ismobile" class="aminui-side-split">
                <div class="aminui-side-split-top">
                    <router-link :to="config.DashboardUrl">
                        <img class="logo" :title="config.AppName" src="@/assets/image/logo.png">
                    </router-link>
                </div>
                <div class="adminui-side-split-scroll">
                    <el-scrollbar>
                        <ul>
                            <li v-for="item in navList" :key="item" :class="pmenu.path === item.path ? 'active':''" @click="showMenu(item)">
                                <ui-icon v-if="item.icon" :type="item.icon" class="el-menu-top-icon" />
                                <p>{{ item.title }}</p>
                            </li>
                        </ul>
                    </el-scrollbar>
                </div>
            </div>
            <div v-if="!ismobile && nextMenu.length > 0 || !pmenu.component" :class="menuIsCollapse ? 'aminui-side isCollapse' : 'aminui-side'">
                <div v-if="!menuIsCollapse" class="adminui-side-top">
                    <h2>{{ pmenu.meta.title }}</h2>
                </div>
                <div class="adminui-side-scroll">
                    <el-scrollbar>
                        <el-menu :default-active="active" router :collapse="menuIsCollapse" :unique-opened="true">
                            <nav-menu :navMenus="nextMenu"></nav-menu>
                        </el-menu>
                    </el-scrollbar>
                </div>
                <div class="adminui-side-bottom" @click="onMenuIsCollapse">
                    <el-icon><el-icon-expand v-if="menuIsCollapse"/><el-icon-fold v-else /></el-icon>
                </div>
            </div>
            <side-m v-if="ismobile"></side-m>
            <div class="aminui-body el-container">
                <topbar>
                    <userbar></userbar>
                </topbar>
                <tags v-if="!ismobile && layoutTags"></tags>
                <div class="adminui-main" id="adminui-main">
                    <router-view v-slot="{ Component }">
                        <keep-alive :include="keepLiveRoute">
                            <component :is="Component" :key="$route.fullPath" v-if="routeShow"/>
                        </keep-alive>
                    </router-view>
                    <iframe-view></iframe-view>
                </div>
            </div>
        </section>
    </template>

    <div class="main-maximize-exit" @click="exitMaximize"><el-icon><el-icon-close /></el-icon></div>
    <div class="layout-setting" @click="openSetting"><el-icon><el-icon-brush-filled /></el-icon></div>
    <el-drawer title="布局设置" v-model="settingDialog" :size="400" append-to-body destroy-on-close>
        <setting ref="settingRef"></setting>
    </el-drawer>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, watch, nextTick, computed } from 'vue'
    import { useNavlistStore, useLayoutStore } from '@/store'
    import C from '@/config'
    import Tags from './components/tags'
    import Topbar from './components/topbar'
    import Userbar from './components/userbar'
    import NavMenu from './components/NavMenu'
    import Setting from './components/setting'
    import SideM from './components/SideM'
    import Cache from '@/utils/cache'

    export default defineComponent({
        components: {
            Tags,
            Topbar,
            Userbar,
            NavMenu,
            Setting,
            SideM
        },
        setup() {
            const StoreNavlist = useNavlistStore()
            const StoreLayout = useLayoutStore()

            const { proxy } = getCurrentInstance()
            const config = ref(C)
            const settingDialog = ref(false)
            const nextMenu = ref([])
            const pmenu = ref([])
            const active = ref('')
            const settingRef = ref()
            const navList = computed(() => StoreNavlist.list)
            const keepLiveRoute = computed(() => StoreLayout.keepLiveRoute)
            const routeShow = computed(() => StoreLayout.routeShow)
            const layout = computed(() => StoreLayout.layout)
            const ismobile = computed(() => StoreLayout.ismobile)
            const layoutTags = computed(() => StoreLayout.layoutTags)
            const menuIsCollapse = computed(() => StoreLayout.menuIsCollapse)
            // new
            const openSetting = () => {
                settingDialog.value = true
            }
            const onLayoutResize = () => {
                StoreLayout.ismobile = document.body.clientWidth < 992
            }

            // 路由监听高亮
            const showThis = () => {
                pmenu.value = proxy.$router.currentRoute.value.meta.breadcrumb ? proxy.$router.currentRoute.value.meta.breadcrumb[0] : {}
                nextMenu.value = filterUrl(pmenu.value.children)
                nextTick(() => {
                    active.value = proxy.$router.currentRoute.value.meta.active || proxy.$router.currentRoute.value.fullPath
                })
            }
            // 点击显示
            const showMenu = (route) => {
                pmenu.value = route
                nextMenu.value = filterUrl(route.children)
                if ((!route.children || route.children.length === 0) && route.component) {
                    proxy.$router.push({ path: route.path })
                }
            }
            // 转换外部链接的路由
            const filterUrl = (map) => {
                var newMap = []
                map && map.forEach(item => {
                    item.meta = item.meta ? item.meta : {}
                    // 处理隐藏
                    if (item.meta.hidden || item.meta.type === 'button') {
                        return false
                    }
                    // 处理http
                    if (item.meta.type === 'iframe') {
                        item.path = `/i/${item.name}`
                    }
                    // 递归循环
                    if (item.children && item.children.length > 0) {
                        item.children = filterUrl(item.children)
                    }
                    newMap.push(item)
                })
                return newMap
            }
            // 退出最大化
            const exitMaximize = () => {
                document.getElementById('app').classList.remove('main-maximize')
            }

            onLayoutResize()
            window.addEventListener('resize', onLayoutResize)
            showThis()

            const dark = ref(Cache.get('APP_DARK') || false)
            if (dark.value) {
                document.documentElement.classList.add('dark')
            } else {
                document.documentElement.classList.remove('dark')
            }

            const onMenuIsCollapse = () => {
                let menuIsCollapse = Cache.get('menuIsCollapse')
                Cache.add('menuIsCollapse', !menuIsCollapse)
                StoreLayout.menuIsCollapse = !menuIsCollapse
            }

            return {
                config,
                settingDialog,
                nextMenu,
                pmenu,
                active,
                navList,
                keepLiveRoute,
                routeShow,
                layout,
                ismobile,
                layoutTags,
                menuIsCollapse,

                showMenu,
                exitMaximize,

                openSetting,

                settingRef,
                onMenuIsCollapse
            }
        }
    })
</script>
